// Rejection 50099 ("Need prior auto") is only cleared by the UW rules when the recalculation
// carries global.staffProvidedPriorCoverage — a deliberate-intent marker, since the offer's
// prior-coverage fields hold plausible defaulted values that must not clear the rejection on
// unrelated edits. The field is not in the GlobalDetailsInput whitelist (core/helpers/sanitize.js),
// so it has to be added after sanitization, the same way the resubmit-offer-modal does.
// This marks the standard "Update offer" path when staff edited the prior-carrier card while
// 50099 was present. See gobranch/branch#35132.
//
// Deliberately scoped to 50099 even though the card also unlocks for 50007/50038: those codes
// clear without the flag, and the flag is never reset once persisted (offer merges copy it),
// so setting it more broadly would let a stale flag auto-clear a later 50099.

import { rejectCodes } from '@ourbranch/lookups';

// The editable fields on the "Information from Prior Carrier" card
// (common/components/auto/prior-coverage), which the 50099 rejection unlocks.
const PRIOR_COVERAGE_FIELDS = [
  'currentAutoCarrier',
  'continuousAutoCoverageStartDate',
  'mostRecentAutoInsuranceCoverageEndDate',
  'priorIndividualBILimit',
  'priorOccurrenceBILimit',
  'priorUmIndividualBodilyInjury',
  'priorUmOccurrenceBodilyInjury'
];

// Form values arrive as strings while the stored offer has numbers; absent, null, and '' all mean "empty"
const normalizeForComparison = (value) =>
  value === null || value === undefined || value === '' ? null : String(value);

export const markStaffProvidedPriorCoverage = (formattedDetails, offer) => {
  const hasNeedPriorAutoRejection = offer?.rejections?.some(
    (rejection) => rejection.value === rejectCodes.NEED_PRIOR_AUTO_COVERAGE_DETAILS
  );
  if (!hasNeedPriorAutoRejection || !formattedDetails?.global) {
    return formattedDetails;
  }

  const storedGlobal = offer?.quote?.global || {};
  const priorCoverageEdited = PRIOR_COVERAGE_FIELDS.some(
    (field) => normalizeForComparison(formattedDetails.global[field]) !== normalizeForComparison(storedGlobal[field])
  );

  if (priorCoverageEdited) {
    formattedDetails.global = { ...formattedDetails.global, staffProvidedPriorCoverage: true };
  }
  return formattedDetails;
};
